import { ADD_CONTACTS, FETCHING_CONTACTS, FETCHED_CONTACTS, CLEAR_ALL } from '../constants';

interface ContactsState {
  list: Record<string, any[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: ContactsState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function contactsReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): ContactsState {
  switch (type) {
    case CLEAR_ALL:
      return initialState;
    case ADD_CONTACTS:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
      };
    case FETCHING_CONTACTS:
      return { ...state, fetching: payload };
    case FETCHED_CONTACTS:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    default:
      return state;
  }
}
